module.exports = __webpack_public_path__ + "img/BG-Cloud.d6820238.jpg";